export const IMAGE_MIME_TYPE = {
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
} as const
Object.freeze(IMAGE_MIME_TYPE)
export type IMAGE_MIME_TYPE = (typeof IMAGE_MIME_TYPE)[keyof typeof IMAGE_MIME_TYPE]

export const IMAGE_HOMEPAGE_MAP = {
  desktop: {
    'default': 'homepage/herosection-image-desktop-v4.webp',
    'canadian-owner': 'homepage/herosection-image-ca-desktop-v3.webp',
    'zoomed-in-class-c': 'homepage/herosection-image-desktop-zoomed-blue-class-c.webp',
  },
  mobile: {
    'default': 'homepage/herosection-image-mobile-v4.webp',
    'canadian-owner': 'homepage/herosection-image-ca-mobile-v3.webp',
    'zoomed-in-class-c': 'homepage/herosection-image-mobile-zoomed-blue-class-c.webp',
  },
} as const
Object.freeze(IMAGE_HOMEPAGE_MAP)
export type IMAGE_HOMEPAGE_MAP = (typeof IMAGE_HOMEPAGE_MAP)[keyof typeof IMAGE_HOMEPAGE_MAP]

/**
 * These constants map to our image worker presets.
 * Width and height are added manually as well, in order to be used on img elements (for example).
 *
 * This mapping is manual and needs to be in sync with: https://github.com/RVezy/rvezy-image-worker
 */
export const IMAGE_PRESETS = {
  SQUARE_SM: {
    key: 'square-sm',
    width: 96,
    height: 96,
  },
  SQUARE_MD: {
    key: 'square-md',
    width: 192,
    height: 192,
  },
  SQUARE_LG: {
    key: 'square-lg',
    width: 384,
    height: 384,
  },

  LANDSCAPE_SM: {
    key: 'landscape-sm',
    width: 480,
    height: 320,
  },
  LANDSCAPE_MD: {
    key: 'landscape-md',
    width: 960,
    height: 640,
  },
  LANDSCAPE_LG: {
    key: 'landscape-lg',
    width: 1280,
    height: 854,
  },
  LANDSCAPE_XL: {
    key: 'landscape-xl',
    width: 1920,
    height: 1280,
  },

  PORTRAIT_SM: {
    key: 'portrait-sm',
    width: 320,
    height: 480,
  },
  PORTRAIT_MD: {
    key: 'portrait-md',
    width: 640,
    height: 960,
  },

  WIDE_SM: {
    key: 'wide-sm',
    width: 640,
    height: 360,
  },
  WIDE_MD: {
    key: 'wide-md',
    width: 1280,
    height: 720,
  },
  WIDE_LG: {
    key: 'wide-lg',
    width: 1920,
    height: 1080,
  },

  NATIVE_SM: {
    key: 'native-sm',
    width: 480,
    height: 480,
  },
  NATIVE_MD: {
    key: 'native-md',
    width: 960,
    height: 960,
  },
  NATIVE_LG: {
    key: 'native-lg',
    width: 1280,
    height: 1280,
  },
  NATIVE_XL: {
    key: 'native-xl',
    width: 1920,
    height: 1920,
  },

  OG: {
    key: 'og',
    width: 1200,
    height: 630,
  },
} as const
Object.freeze(IMAGE_PRESETS)
export type IMAGE_PRESETS = (typeof IMAGE_PRESETS)[keyof typeof IMAGE_PRESETS]

export const MISSING_IMAGE_ASSET = '/web-app/images/_missing-image.png'
